import { SxProps, Theme } from '@mui/material';

export const alertSX: SxProps<Theme> = {
	alignItems: 'center',
	'.MuiAlert-message': {
		whiteSpace: 'normal',
		overflowWrap: 'break-word',
		wordWrap: 'break-word',
		wordBreak: 'break-word',
		display: 'flex',
		alignItems: 'center',
		fontSize: '15px',
	},
	'.MuiAlert-icon': {
		marginRight: '10px',
	},
};

export const wishListAlertSX: SxProps<Theme> = {
	backgroundColor: 'black',
	'.MuiAlert-action, .MuiLink-root, .MuiAlert-message': {
		color: 'white',
	},
	'.MuiAlert-action': {
		p: '4px 0 0 0',
	},
};

export const actionsSX: SxProps<Theme> = {
	':hover': {
		cursor: 'pointer',
	},
};

export const genericAlertSX: SxProps<Theme> = {
	'.MuiAlert-message': {
		whiteSpace: 'normal',
		overflowWrap: 'break-word',
		wordWrap: 'break-word',
		wordBreak: 'break-word',
		display: 'flex',
		alignItems: 'center',
		fontSize: '15px',
	},

	'&.MuiAlert-root': {
		backgroundColor: '#2F2F2F !important',
		color: 'white',
	},
};
